import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  actualites: []
};

const slice = createSlice({
  name: 'actualites',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET Actualites
    getActualitesSuccess(state, action) {
      state.isLoading = false;
      state.actualites = action.payload;
    },


  },
});

// Reducer
export default slice.reducer;


export function getActualites() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/actualites');

      dispatch(slice.actions.getActualitesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
